<div class="w-100 h-100vh bg-fl">
  <div class="header pb-8 pt-5">
    <div class="container-fluid">
      <div class="header-body">
        <!-- Card stats -->
        <div class="row justify-content-center" *ngIf="!isAuthenticated()">
          <div class="col-12">
            <h1 class="display-2 text-center text-white">{{ 'home.subtitle' | translate }}</h1>
            <h1 class="display-5 text-center text-white">{{ 'home.notlogged.message' | translate }}</h1>
          </div>
        </div>
        <div class="row justify-content-center" *ngIf="!isAuthenticated()">
          <div class="mx-auto">
            <img src="/content/images/brand/ipdj.png" alt="IPDJ" style="height: 100px" />
          </div>
        </div>
        <div class="row" *ngIf="isAuthenticated()">
          <div class="col-xl-3 col-lg-6">
            <div class="card card-stats mb-4 mb-xl-0">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h5 class="card-title text-uppercase text-muted mb-0">Exemplo1</h5>
                    <span class="h2 font-weight-bold mb-0">{{ example1 }}</span>
                  </div>
                  <div class="col-auto">
                    <div class="icon icon-shape bg-danger text-white rounded-circle shadow">
                      <i class="fas fa-chart-bar"></i>
                    </div>
                  </div>
                </div>
                <p class="mt-3 mb-0 text-muted text-sm">
                  <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> {{ 100 }}%</span>
                  <span class="text-nowrap">No último mês</span>
                </p>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-6">
            <div class="card card-stats mb-4 mb-xl-0">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h5 class="card-title text-uppercase text-muted mb-0">Exemplo 2</h5>
                    <span class="h2 font-weight-bold mb-0">{{ example2 }}</span>
                  </div>
                  <div class="col-auto">
                    <div class="icon icon-shape bg-warning text-white rounded-circle shadow">
                      <i class="fas fa-chart-pie"></i>
                    </div>
                  </div>
                </div>
                <p class="mt-3 mb-0 text-muted text-sm">
                  <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> {{ 100 }}%</span>
                  <span class="text-nowrap">No último mês</span>
                </p>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-6">
            <div class="card card-stats mb-4 mb-xl-0">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h5 class="card-title text-uppercase text-muted mb-0">Exemplo 3</h5>
                    <span class="h2 font-weight-bold mb-0">{{ example3 }}</span>
                  </div>
                  <div class="col-auto">
                    <div class="icon icon-shape bg-yellow text-white rounded-circle shadow">
                      <i class="fas fa-users"></i>
                    </div>
                  </div>
                </div>
                <p class="mt-3 mb-0 text-muted text-sm">
                  <span class="text-warning mr-2"><i class="fas fa-arrow-down"></i>{{ 0 }}</span>
                  <span class="text-nowrap">No último mês</span>
                </p>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-6">
            <div class="card card-stats mb-4 mb-xl-0">
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <h5 class="card-title text-uppercase text-muted mb-0">Exemplo 4</h5>
                    <span class="h2 font-weight-bold mb-0">{{ example4 }} </span>
                  </div>
                  <div class="col-auto">
                    <div class="icon icon-shape bg-info text-white rounded-circle shadow">
                      <i class="fas fa-percent"></i>
                    </div>
                  </div>
                </div>
                <p class="mt-3 mb-0 text-muted text-sm">
                  <span class="text-success mr-2"><i class="fas fa-arrow-up"></i>0</span>
                  <span class="text-nowrap">no último mês</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
